define('country-text',['require','i18next','lib/countries/localize-and-sort-countries'],function (require) {
    var i18n = require('i18next');
    var localizeAndSortCountries = require('lib/countries/localize-and-sort-countries');

    /*  Returns a string that will be viewed by the user.
     *   No country: None
     *   1 country: France
     *   2 countries: France and Germany
     *   3 or more countries: France and 5 other countries.
     *   The preferred country should always be first, otherwise the first alphabetically.
     */
    var countryString = function (selectedCountries, preferredCountry, defaultCountries) {
        var text = '';
        var and = i18n.t('settings.overlay.and');
        var other = i18n.t('settings.overlay.other');

        // default countries is optional
        var defaults = defaultCountries || [];
        var sortedCountries = [];

        if (selectedCountries && selectedCountries.length > 0) {
            sortedCountries = localizeAndSortCountries(selectedCountries);
        } else {
            sortedCountries = localizeAndSortCountries(defaults);
        }

        if (sortedCountries.length === 0) {
            // should only the be the case of a new user
            text = i18n.t('settings.overlay.none');
        } else if (sortedCountries.length === 1) {
            text = i18n.t('countries.' + sortedCountries[0]);
        } else if (sortedCountries.length === 2) {
            //  If the preferred country is second, swap the positions
            if (sortedCountries.indexOf(preferredCountry) === 1) {
                var temp = sortedCountries[0];
                sortedCountries[0] = sortedCountries[1];
                sortedCountries[1] = temp;
            }
            text = i18n.t('countries.' + sortedCountries[0]);
            text = text + ' ' + and;
            text = text + ' ' + i18n.t('countries.' + sortedCountries[1]);
        } else {
            var count = sortedCountries.length - 1;
            if (sortedCountries.indexOf(preferredCountry) > -1) {
                text = i18n.t('countries.' + preferredCountry);
                text = text + ' ' + and + ' ' + count + ' ' + other;
            } else {
                text = i18n.t('countries.' + sortedCountries[0]);
                text = text + ' ' + and + ' ' + count + ' ' + other;
            }
        }
        return text;
    };
    return countryString;
});

